var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon",class:_vm.value ? 'success' : 'error',on:{"click":_vm.click}})
}
var staticRenderFns = []

export { render, staticRenderFns }